module.exports = __webpack_public_path__ + "static/media/visa.e95aa8a1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/visa.svg
// module id = 496
// module chunks = 0